// Shared sessionStorage accessor for "which board is this Kanban module
// instance currently showing" — used both by KanbanModule (which persists it)
// and ChatModulePane (which reads it synchronously to decide whether the
// module-options menu's board-specific items are enabled). Kept as a pure,
// React-free function (no `window` global, no effect) so the value is
// available on the FIRST render of any consumer, not just after a passive
// effect has run post-paint (#5568: the previous `window.__xaviorKanbanActiveBoard`
// map was populated by a `useEffect` in KanbanModule and read synchronously in
// ChatModulePane — on module switch-back, ChatModulePane's render could run
// before the newly-mounted KanbanModule's effect had repopulated the map,
// leaving the menu stuck disabled).
import { readSessionPersisted } from '@/common/hooks/useSessionPersistedState';

/** sessionStorage key a given Kanban module instance persists its open board under. */
export function kanbanActiveBoardStorageKey(moduleId: string): string {
  return `xavior:kanban.activeBoard:${moduleId}`;
}

/** Whether the given Kanban module instance currently has a board open. */
export function isKanbanBoardOpen(moduleId: string): boolean {
  return Boolean(
    readSessionPersisted<string | null>(
      kanbanActiveBoardStorageKey(moduleId),
      null,
      (v): v is string | null => v === null || typeof v === 'string',
    ),
  );
}
